// /docs: fills config-driven numbers (split, payout timing, daily limit, code prefix, site domain), shows the
// AI-check rule only when the server runs it, lists contract addresses, and highlights the section in view.
import { config, epochName, explorerAddress, siteHost } from "../lib/config.js";
import { esc, formatSol, pct } from "../lib/format.js";
import { boot } from "../lib/page.js";
import { $$ } from "../lib/ui.js";

function fill(cfg) {
  const host = cfg.explorer.replace(/^https?:\/\//, "");
  const values = {
    epochMinutes: String(cfg.epochMinutes),
    epochName: epochName(cfg),
    dailyLimit: String(cfg.dailyPostLimit),
    harvestMinutes: String(cfg.harvestMinutes),
    codeExample: `${cfg.codePrefix}1a2b3c4d`,
    domain: siteHost(cfg),
    creatorPct: pct(cfg.split.creatorBps),
    shillPct: pct(cfg.split.shillBps),
    platformPct: pct(cfg.split.platformBps || 0),
    launchFee: `${formatSol(cfg.launchFeeLamports)} SOL`,
  };
  $$("[data-cfg]").forEach((el) => {
    const k = el.dataset.cfg;
    if (k === "explorerLink") { el.href = cfg.explorer; el.textContent = host; return; }
    if (k in values) el.textContent = values[k];
  });
  $$("[data-ai]").forEach((el) => { el.hidden = !cfg.aiCheck; });
  const addrs = { pump: "6EF8rrecthR5Dkzon8Nwu78hRvfCKubJ14M5uBEwF6P", fees: "pfeeUxB6jkeY1Hxd7CsFCAjcbHA9rWtchMGdZ6VojVZ" };
  $$("[data-addr]").forEach((el) => {
    const a = addrs[el.dataset.addr];
    el.innerHTML = a
      ? `<a href="${esc(explorerAddress(a))}" target="_blank" rel="noopener noreferrer" title="View on the explorer">${esc(a)}</a>`
      : '<span class="muted">Not deployed yet</span>';
  });
}

function scrollSpy() {
  if (!("IntersectionObserver" in window)) return;
  const links = new Map($$(".docs-nav a[href^='#']").map((a) => [a.getAttribute("href").slice(1), a]));
  const visible = new Set();
  const io = new IntersectionObserver((entries) => {
    for (const e of entries) e.isIntersecting ? visible.add(e.target.id) : visible.delete(e.target.id);
    const first = [...links.keys()].find((id) => visible.has(id));
    links.forEach((a, id) => (id === first ? a.setAttribute("aria-current", "true") : a.removeAttribute("aria-current")));
  }, { rootMargin: "-100px 0px -55% 0px" });
  links.forEach((_, id) => { const s = document.getElementById(id); if (s) io.observe(s); });
}

async function main() {
  fill(config());
  scrollSpy();
  fill(await boot());
}

main().catch((e) => console.error(e));
